export default "__VITE_ASSET__CNUBmq3h__"